var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"my_order"},[_c('h3',{staticClass:"class_title"},[_vm._v("地址管理")]),_c('addRess')],1)}
var staticRenderFns = []

export { render, staticRenderFns }